import React, { useEffect, useState } from 'react'

import { Box, Slide } from '@mui/material'

import useVersionCheck from '../../hooks/useVersionCheck'
import styles from './UpdateAvailableChip.styles'

const reloadPage = () => {
  window.location.reload()
}

const RefreshGlyph: React.FC = () => (
  <svg
    viewBox="0 0 16 16"
    width="12"
    height="12"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M13.2 3.2v3.4h-3.4" />
    <path d="M2.8 12.8V9.4h3.4" />
    <path d="M3.3 6.6a5 5 0 0 1 8.8-1.3l1.1 1.3" />
    <path d="M12.7 9.4a5 5 0 0 1-8.8 1.3l-1.1-1.3" />
  </svg>
)

const DismissGlyph: React.FC = () => (
  <svg
    viewBox="0 0 10 10"
    width="9"
    height="9"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.6"
    strokeLinecap="round"
    aria-hidden="true"
  >
    <path d="M2 2l6 6M8 2L2 8" />
  </svg>
)

const UpdateAvailableChip: React.FC = () => {
  const { isStale, latest } = useVersionCheck()
  const [dismissedCommit, setDismissedCommit] = useState<string | null>(null)

  useEffect(() => {
    if (latest && dismissedCommit && latest.commit !== dismissedCommit) {
      setDismissedCommit(null)
    }
  }, [latest, dismissedCommit])

  const dismissedForCurrent = Boolean(latest && dismissedCommit && latest.commit === dismissedCommit)
  const shouldShow = isStale && !dismissedForCurrent

  const handleDismiss = () => {
    if (latest) setDismissedCommit(latest.commit)
  }

  return (
    <Box sx={styles.anchor} aria-live="polite">
      <Slide
        direction="up"
        in={shouldShow}
        mountOnEnter
        unmountOnExit
        timeout={{ enter: 440, exit: 220 }}
        easing={{ enter: 'cubic-bezier(0.32, 0.72, 0, 1)', exit: 'cubic-bezier(0.4, 0, 1, 1)' }}
      >
        <Box role="status" aria-label="Update available" sx={styles.chip}>
          <Box component="span" aria-hidden="true" sx={styles.dot} />

          <Box component="span" sx={styles.label}>
            A new version is available
          </Box>

          <Box component="button" type="button" onClick={reloadPage} sx={styles.refreshButton}>
            <Box component="span" className="chip-refresh-icon" sx={styles.refreshIcon}>
              <RefreshGlyph />
            </Box>
            Refresh
          </Box>

          <Box
            component="button"
            type="button"
            aria-label="Dismiss update notice"
            onClick={handleDismiss}
            sx={styles.dismissButton}
          >
            <DismissGlyph />
          </Box>
        </Box>
      </Slide>
    </Box>
  )
}

export default UpdateAvailableChip
